/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_TitleInputs */

const da_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies og lokal lagring`)
};

/** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */
const en_privacy_cookies_title = da_privacy_cookies_title;

/**

* @param {Privacy_Cookies_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_title = /** @type {((inputs?: Privacy_Cookies_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_cookies_title(inputs)
	return /** @type {LocalizedString} */ ("Cookies og lokal lagring")
});